/* istanbul ignore file */

import ptom from "../helpers/ptom";
import Theme from "./interfaces/Theme";

export const colors = {
  white: '#fff',
  primary: '#3B414E',
  secondary: '#63B414E',
  lightGray: '#F3F6F8',
  title: '#3B414E', // alle teksten in deze hypotheekbondkleur
  subTitle: '#3B414E',
  reportName: '#A0C734',
  success: '#AAC758',
  error:  '#F3544B',
  info: '#3B414E',
  chartGreen: '#AAC758',
  chartBlue: '#3B83C7',
  chartBlueLight: '#C4DAEE',
  chartRed: '#F3544B',
  chartRedLight: '#FBCCC9',
  dashedBorder: '#DBDBDB',
};

const defaultTheme: Theme = {
  fontFace: 'Open Sans',
  titleFontFace: 'Open Sans',
  ptom,
  colors,
  text:{
    fontSize: '2.54mm',
    lineHeight: '12.2625pt',
  },
  spacing: {
    s: ptom(4),
    m: ptom(8),
    l: ptom(16),
    xl: ptom(24),
    xxl: ptom(32)
  },    
  tableGap: ptom(16),
  titleFontWeight: 800,
  fg: {
    white: colors.white,
    primary: colors.primary,
    secondary: colors.secondary,
    lightGray: colors.lightGray,
    title: colors.title,
    subTitle: colors.subTitle,
    reportName: colors.reportName,
    success: colors.success,
    error: colors.error,
    info: colors.info,
    linkColor: colors.primary,
  },
  bg: {
    primary: 'none',
    secondary:  '#F3F6F8',
    white: colors.white,
    alterRow: '#F3F6F8',
    rowSummary: '#3B414E',
    columnSummary: '#d0dce8',
    success: 'rgba(149, 193, 31, 0.16)',
    error:  'rgba(243, 84, 75, 0.16)',
    dataBlock: 'none',
    applicant: '#AAC758',
    partner: '#3B83C7',
    tableHighlight:  'rgba(59, 131, 199, 0.3)',
    together: '#EE964B',
  },
  borders: {
    radius: ptom(10),
    color: 'none',
  },
  dataRow: {
    borderTop: `${ptom(1)} dashed ${colors.lightGray}`,
    backgroundColor: colors.white,
  },
  highlightRow: {
    backgroundColor: colors.primary,
    color: colors.white,
    borderRadius: ptom(12),
    fontWeight: 800,
  }
};

export default defaultTheme;
